module.exports = __webpack_public_path__ + "img/Stop_War_HD 2_00073.38fa59a3.png";